// extracted by mini-css-extract-plugin
export default {"modalOverlay":"iF-z","modalContent":"jF-z","header":"kF-z","close":"lF-z"};